import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import { CoreCardProvider } from './InputCoreCard.tsx';
import Rater from './Rater.tsx';
import Viewer from './Viewer.tsx';
import Navbar from './Navbar.tsx';
import './App.css';

function App() {
  return (
    <div className='body'>
      <CoreCardProvider>
        <Router>
          <Navbar/>
          <Routes>
            <Route exact path='/' element={<Rater/>} />
            <Route exact path='/memories' element={<Viewer/>} />
          </Routes>
        </Router>
      </CoreCardProvider>
    </div>
  );
}

export default App;
